<template>
    <div class="replyItemWrap">
        <div class="replyItemName">
            <span class="curp" @click="jumpOut">
                {{cont.nickname}}
            </span>
        </div>
        <div class="replyItemCont">{{replayContent}}</div>
    </div>
</template>

<script>
export default {
    name: 'ReplyItem',
    props: ['cont'],
    computed: {
        replayContent() {
            // console.log( this.cont.content)
            let newStr = this.$utils.thscSnsBaselibUtils.utf16toEntitie(this.cont.content);
            newStr = this.$utils.thscSnsBaselibUtils.uncodeUtf16(newStr);
            return this.$utils.thscSnsBaselibUtils.formatImgToEmoji(newStr);
        },
    },
    methods: {
        jumpOut() {
            this.$sendStat(`pc_newschrome_${window.statSeq}.comments.names.click`)
            window.open(`//t.10jqka.com.cn/${this.cont.userid}/`)
        }
    }
}
</script>

<style lang="less">
@import './index.less';
</style>
